<template>
  <img
    class="object-cover"
    src="@/assets/images/navbar-icons/nav-quests-icon.webp"
  >
</template>